module.exports = __webpack_public_path__ + "static/media/420GriffinStNW_2018-06-05_40.457a97b3.jpg";